import {
  LaborRole,
  Quote,
  QuoteMode,
  QuoteStatus,
  BidFormTemplate,
  ChecklistItem,
  PdfExportSettings,
  Kit,
  Customer,
  CustomerStatus,
  CompanyInfo,
  SchedulingSettings,
} from "./types";

// Re-export app configuration constants for convenience
export { APP_CONFIG } from "./constants/app";

// Oler Industries Logo (SVG Base64 Encoded - Original with CSS Classes)
// Dimensions: 652x567
// This is the original SVG with proper CSS classes (.cls-1 and .cls-2) preserved
// Light mode: .cls-1 = #4a4a4d (dark gray), .cls-2 = #00a0ff (brand blue)
export const OLER_LOGO =
  "data:image/svg+xml;base64,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";

// Oler Industries Logo - Dark Mode Version (SVG Base64 Encoded)
// Dimensions: 652x567
// Dark mode: .cls-1 = #fff (white), .cls-2 = #00a0ff (brand blue)
export const OLER_LOGO_DARK =
  "data:image/svg+xml;base64,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";

export const DEFAULT_GST_RATE = 0.05;
export const DEFAULT_PST_FACTOR = 1.07;
export const DEFAULT_MARKUP = 1.25;
export const DEFAULT_CONTINGENCY = 0.05;
export const DEFAULT_SHIFT_HOURS = 8;
export const DEFAULT_CREW_SIZE = 1; // P1.3: default crew size for schedule calculations
export const DEFAULT_VALIDITY_DAYS = 30; // Default validity in days

/**
 * Default scheduling settings (P1.3)
 * These align with the Schedule Plan Sync Contract:
 * - Working days: Mon-Fri (1-5)
 * - Working hours: 08:00-16:00 local
 * - Holidays: empty by default
 * - Crew size: 1
 * - Shift hours: 8
 * - Admin buffer: 5 working days
 */
export const DEFAULT_SCHEDULING_SETTINGS: SchedulingSettings = {
  workingDays: [1, 2, 3, 4, 5], // Monday-Friday (0=Sunday, 6=Saturday)
  workingHoursStart: "08:00",
  workingHoursEnd: "16:00",
  holidays: [], // Empty by default; YYYY-MM-DD format
  defaultCrewSize: 1,
  defaultShiftHours: 8,
  defaultAdminBufferDays: 5,
};

export const DEFAULT_COMPANY_INFO: CompanyInfo = {
  name: "Oler Industries Inc.",
  address: "123 Industrial Way, Kelowna BC",
  email: "estimating@oler.ca",
  phone: "(250) 555-0123",
  gstNumber: "888999123 RT0001",
};

export const CUSTOMER_CATEGORIES = [
  "Industrial",
  "Commercial",
  "Residential",
  "Municipal",
  "General Contractor",
  "Other",
];

export const VOLATILE_KEYWORDS = ["copper", "wire", "cable", "steel", "aluminum", "conduit"];

export const DEFAULT_PDF_SETTINGS: PdfExportSettings = {
  laborDisplayMode: "DETAILED",
  materialDisplayMode: "DETAILED",
  showScope: true,
  template: "STANDARD",
};

export const INTERNAL_TASK_TYPES = [
  "Quoting / Estimating",
  "Project Management",
  "Marketing / Sales",
  "Admin / Finance",
  "Shop Maintenance",
  "Travel (Unbillable)",
  "Training",
];

export const LABOR_ROLES: LaborRole[] = [
  { id: "eng", name: "Controls Engineer / PLC Programmer", rate: 165.0, costRate: 95.0 },
  { id: "me", name: "Master Electrician", rate: 125.0, costRate: 75.0 },
  { id: "jm", name: "Journeyman Electrician", rate: 105.0, costRate: 65.0 },
  { id: "app", name: "Apprentice", rate: 75.0, costRate: 40.0 },
  { id: "inst", name: "Instrumentation Tech", rate: 135.0, costRate: 80.0 },
  { id: "pm", name: "Project Manager", rate: 145.0, costRate: 85.0 },
];

export const KIT_CATEGORIES = [
  "Industrial",
  "Commercial",
  "Residential",
  "Municipal",
  "Service",
  "Other",
];

export const DEFAULT_KITS: Kit[] = [
  {
    id: "kit-duplex-pump",
    name: "Duplex Pump Panel (5HP-20HP)",
    description: "NEMA 4X Panel build, install, and commissioning for duplex pump station.",
    category: "Industrial",
    laborSteps: [
      { id: "dp1", description: "Panel Layout & Fabrication", roleId: "jm", manHours: 12 },
      { id: "dp2", description: "PLC Programming (Alternation logic)", roleId: "eng", manHours: 6 },
      { id: "dp3", description: "Site Install & Mounting", roleId: "jm", manHours: 4 },
      { id: "dp4", description: "Float/Transducer Termination", roleId: "app", manHours: 2 },
      { id: "dp5", description: "Start-up & Commissioning", roleId: "eng", manHours: 4 },
    ],
    materialLines: [
      {
        id: "m1",
        description: "36x30x10 NEMA 4X Enclosure",
        vendor: "E.B. Horsman",
        unitCost: 850,
        qty: 1,
        pstFactor: 1.07,
        markupFactor: 1.25,
      },
      {
        id: "m2",
        description: "MicroPLC & I/O Cards",
        vendor: "AutomationDirect",
        unitCost: 650,
        qty: 1,
        pstFactor: 1.07,
        markupFactor: 1.35,
      },
      {
        id: "m3",
        description: "Motor Starters / Overloads",
        vendor: "E.B. Horsman",
        unitCost: 450,
        qty: 2,
        pstFactor: 1.07,
        markupFactor: 1.25,
      },
      {
        id: "m4",
        description: "Pilot Lights, Switches, Terminals",
        vendor: "E.B. Horsman",
        unitCost: 350,
        qty: 1,
        pstFactor: 1.07,
        markupFactor: 1.25,
      },
    ],
  },
  {
    id: "kit-scada-remote",
    name: "SCADA Remote Site Upgrade",
    description: "Upgrade existing RTU to modern cellular modem & tie into central SCADA.",
    category: "Municipal",
    laborSteps: [
      { id: "sc1", description: "Design & Dwg Update", roleId: "eng", manHours: 4 },
      { id: "sc2", description: "Demo old RTU / Install New", roleId: "jm", manHours: 6 },
      { id: "sc3", description: "Antenna Alignment & Cabling", roleId: "app", manHours: 2 },
      {
        id: "sc4",
        description: "SCADA Integration (VTScada/Ignition)",
        roleId: "eng",
        manHours: 8,
      },
    ],
    materialLines: [
      {
        id: "sm1",
        description: "Cellular Modem / Gateway",
        vendor: "Moxa",
        unitCost: 950,
        qty: 1,
        pstFactor: 1.07,
        markupFactor: 1.2,
      },
      {
        id: "sm2",
        description: "Directional Yagi Antenna & Coax",
        vendor: "Tessco",
        unitCost: 350,
        qty: 1,
        pstFactor: 1.07,
        markupFactor: 1.25,
      },
    ],
  },
  {
    id: "kit-vfd-comm",
    name: "VFD Supply & Commissioning (25HP)",
    description: "Supply 600V VFD, wall mount, terminate, and parameter setup.",
    category: "Industrial",
    laborSteps: [
      { id: "v1", description: "Mount Drive & Line Reactor", roleId: "jm", manHours: 3 },
      { id: "v2", description: "Power & Motor Terminations", roleId: "jm", manHours: 2 },
      { id: "v3", description: "Parameter Config & Auto-tune", roleId: "eng", manHours: 3 },
    ],
    materialLines: [
      {
        id: "vm1",
        description: "25HP 600V VFD (NEMA 1)",
        vendor: "Danfoss",
        unitCost: 2800,
        qty: 1,
        pstFactor: 1.07,
        markupFactor: 1.15,
      },
      {
        id: "vm2",
        description: "Line Reactor (3%)",
        vendor: "E.B. Horsman",
        unitCost: 450,
        qty: 1,
        pstFactor: 1.07,
        markupFactor: 1.25,
      },
    ],
  },
];

export const TERMS_LIBRARY = {
  INDUSTRIAL: `1. VALIDITY: This quote is valid for 30 days.
2. EXCLUSIONS: Permits, utility fees, structural engineering, concrete pads, and hazardous material abatement are excluded unless explicitly stated.
3. SOFTWARE: All PLC/SCADA source code remains the property of Oler Industries until full payment is received.
4. EXISTING CONDITIONS: We are not responsible for troubleshooting pre-existing faults in equipment or wiring not installed by us.
5. NETWORK: Client to provide internet/network access where required for remote connectivity.`,

  MUNICIPAL: `1. COMPLIANCE: Work performed in accordance with local municipal standards and MMCD guidelines.
2. BONDING: Performance bonding is not included in this price but can be provided at an additional rate of 2.5%.
3. AS-BUILTS: Red-line markups provided upon completion. CAD revisions billed hourly.
4. HOURS: Work based on standard M-F 7am-3:30pm. Overtime/Call-outs billed at 1.5x/2.0x.`,

  RESI_COMM: `1. PAYMENT: 50% Deposit required upon acceptance. Balance due upon completion.
2. ACCESS: Client must ensure clear access to work area. Delays due to access will be billed.
3. DRYWALL: Cutting of drywall included, patching/painting is BY OTHERS.
4. WARRANTY: 1 Year warranty on labor. Manufacturer warranty on parts.`,
};

export const BID_FORM_TEMPLATES: BidFormTemplate[] = [
  {
    id: "supp_b",
    name: "Supplemental B - Schedule of Quantities",
    rows: [
      { id: "r1", label: "1.0 Mobilization / Demobilization" },
      { id: "r2", label: "2.0 Civil & Site Prep" },
      { id: "r3", label: "3.0 Demolition & Removals" },
      { id: "r4", label: "4.0 New Electrical Install" },
      { id: "r5", label: "5.0 Controls & Instrumentation" },
      { id: "r6", label: "6.0 Testing, Commissioning & Handover" },
    ],
  },
  {
    id: "city_std_c",
    name: "City Standard Form C - Lump Sum",
    rows: [
      { id: "c1", label: "Total Lump Sum Price" },
      { id: "c2", label: "Cash Allowance - Utilities" },
      { id: "c3", label: "Separate Price - Optional Generator" },
    ],
  },
];

export const SUB_CHECKLIST_TEMPLATE: Omit<ChecklistItem, "id" | "checked">[] = [
  { category: "Scope Clarity", label: "Define exact scope included" },
  { category: "Scope Clarity", label: "Define scope excluded" },
  { category: "Scope Clarity", label: "Identify interfaces (supplies/installs/commissions)" },
  { category: "Scope Clarity", label: "List assumptions (access, shutdowns, permits)" },
  { category: "Scope Clarity", label: "Identify unknowns / RFIs" },
  { category: "Pricing Structure", label: "Quote format is plug-in ready (Lump Sum/Unit Price)" },
  { category: "Pricing Structure", label: "Includes Labour, LOA, Consumables, Rentals" },
  { category: "Pricing Structure", label: "GST charged to GC (on invoice)" },
  { category: "Pricing Structure", label: "Quote expiry & lead times stated" },
  { category: "Schedule & Constraints", label: "Confirm work window (shutdown days)" },
  { category: "Schedule & Constraints", label: "Show planned crew size + shift hours" },
  { category: "Schedule & Constraints", label: "Confirm feasibility (Pass/Fail)" },
  { category: "Risk Management", label: "List risks not owned (hazmat, unknown conditions)" },
  { category: "Risk Management", label: "Define change-order triggers" },
  { category: "Deliverables", label: "Define deliverables (As-builts, Warranty)" },
];

export const PRIME_CHECKLIST_TEMPLATE: Omit<ChecklistItem, "id" | "checked">[] = [
  { category: "Bid Compliance", label: "Confirm all required forms included & signed" },
  { category: "Bid Compliance", label: "Confirm bonding/insurance met" },
  { category: "Bid Compliance", label: "Confirm addenda acknowledged" },
  { category: "Full Scope Coverage", label: "Scope includes all trades & coordination" },
  { category: "Full Scope Coverage", label: "Define self-perform vs sub vs vendor scope" },
  {
    category: "Full Scope Coverage",
    label: "Include project admin (safety, submittals, schedules)",
  },
  { category: "Full Scope Coverage", label: "Commissioning responsibility explicit" },
  { category: "Pricing Structure", label: "Customer form filled exactly as required" },
  { category: "Pricing Structure", label: "GST applied once at bottom" },
  { category: "Pricing Structure", label: "Overhead/profit included" },
  { category: "Vendor Management", label: "Key vendor quotes received & lead times confirmed" },
  { category: "Vendor Management", label: "Sub quotes received & scoped" },
  { category: "Execution Plan", label: "Work plan & shutdown plan summary" },
  { category: "Commercial Terms", label: "Payment terms, Warranty, Change Order process defined" },
  { category: "Final Quality Check", label: "Cross-check totals vs internal estimate" },
  { category: "Final Quality Check", label: "Confirm no double-tax & clean rounding" },
];

export const DEFAULT_CUSTOMERS: Customer[] = [
  {
    id: "c1",
    companyName: "City Waterworks",
    contactName: "Sarah Jenkins",
    email: "s.jenkins@citywater.gov",
    phone: "555-0123",
    billingAddress: {
      line1: "456 Municipal Way",
      city: "Kelowna",
      region: "BC",
      country: "Canada",
    },
    address: "456 Municipal Way, Kelowna BC, Canada",
    category: "Municipal",
    status: CustomerStatus.ACTIVE,
    notes: "Major municipal client. Requires strict adherence to safety forms.",
  },
  {
    id: "c2",
    companyName: "Stephen Engineering Ltd.",
    contactName: "Mike Stephen",
    email: "mike@stepheneng.com",
    phone: "555-0199",
    billingAddress: {
      line1: "789 Tech Park Drive",
      city: "Vancouver",
      region: "BC",
      country: "Canada",
    },
    address: "789 Tech Park Drive, Vancouver BC, Canada",
    category: "General Contractor",
    status: CustomerStatus.ACTIVE,
    notes: "Good general contractor. Pays on time.",
  },
];

export const DEMO_QUOTE: Quote = {
  id: "Q-2023-001",
  clientName: "City Waterworks",
  projectName: "PRV Station Upgrade - Phase 2",
  primeContractor: "Stephen Engineering Ltd.",
  mode: QuoteMode.SUB_TO_PRIME,
  status: QuoteStatus.DRAFT,
  dueDate: "2023-11-15",
  gstRate: DEFAULT_GST_RATE,
  version: 1,
  revisionHistory: [],
  laborRoles: [...LABOR_ROLES],
  defaultMarkup: DEFAULT_MARKUP,
  defaultPst: DEFAULT_PST_FACTOR,
  pdfSettings: DEFAULT_PDF_SETTINGS,
  documentType: "QUOTE",
  showOutageAnalysis: false, // Default DISABLED
  enableLoa: false,
  loaRate: 150,
  outageGroups: [{ id: "og1", name: "Main Station Shutdown", allowedDays: 7 }],
  bidItems: [
    {
      id: "item15",
      code: "15",
      title: "Mobilization & Site Prep",
      part: 2,
      shiftHoursPerDay: 8,
      crewSize: 2,
      contingencyPercent: 0.05,
      notes: "Include trailer setup and safety fencing.",
      laborSteps: [
        { id: "ls1", description: "Transport tools/trailer", roleId: "app", manHours: 8 },
        { id: "ls2", description: "Safety orientation & setup", roleId: "me", manHours: 4 },
      ],
      materialLines: [],
      subcontractLines: [
        {
          id: "sub1",
          description: "Fence Rental (1 Month)",
          vendor: "United Rentals",
          totalCost: 1200,
          unitType: "LUMP",
          qty: 1,
          unitCost: 1200,
          chargesGst: true,
          markupFactor: 1.1,
        },
      ],
    },
    {
      id: "item16",
      code: "16",
      title: "Demo Existing Panels",
      part: 2,
      outageGroupId: "og1",
      shiftHoursPerDay: 12,
      crewSize: 3,
      contingencyPercent: 0.1,
      notes: "Must be done in first 2 days of outage.",
      laborSteps: [
        { id: "ls3", description: "Lockout/Tagout verification", roleId: "me", manHours: 2 },
        { id: "ls4", description: "Disconnect & Remove MCC", roleId: "jm", manHours: 24 },
        { id: "ls5", description: "Cable pull-back", roleId: "app", manHours: 12 },
      ],
      materialLines: [
        {
          id: "mat1",
          description: "Disposal Bins",
          vendor: "WasteMgmt",
          unitCost: 500,
          qty: 2,
          pstFactor: 1.07,
          markupFactor: 1.15,
        },
      ],
      subcontractLines: [],
    },
    {
      id: "item17",
      code: "17",
      title: "Install New PLC & IO",
      part: 2,
      outageGroupId: "og1",
      shiftHoursPerDay: 12,
      crewSize: 2,
      contingencyPercent: 0.05,
      notes: "",
      laborSteps: [
        { id: "ls6", description: "Mount Panel", roleId: "jm", manHours: 6 },
        { id: "ls7", description: "Terminate Field IO (60 pts)", roleId: "jm", manHours: 30 },
        { id: "ls8", description: "QC & Ring-out", roleId: "me", manHours: 8 },
      ],
      materialLines: [
        {
          id: "mat2",
          description: "Wire markers, ferules, zip ties",
          vendor: "E.B. Horsman",
          unitCost: 250,
          qty: 1,
          pstFactor: 1.07,
          markupFactor: 1.3,
        },
      ],
      subcontractLines: [],
    },
  ],
  selectedTemplateId: "supp_b",
  bidFormMappings: {
    r1: ["item15"],
    r3: ["item16"],
    r5: ["item17"],
  },
  checklist: SUB_CHECKLIST_TEMPLATE.map((c, i) => ({ ...c, id: `chk-${i}`, checked: false })),
};
